export const NAMESPACE = 'auth';
